// @ts-nocheck
// Service Worker Registration Utility

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 are considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

const registerValidSW = (swUrl, config) => {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      if (import.meta.env.DEV) {
        console.log('Service Worker registered successfully:', registration);
      }

      // Handle updates
      const handleUpdate = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              if (import.meta.env.DEV) {
                console.log(
                  'New content is available and will be used when all ' +
                    'tabs for this page are closed. See https://cra.link/PWA.'
                );
              }

              // Execute callback
              if (config?.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              if (import.meta.env.DEV) {
                console.log('Content is cached for offline use.');
              }
              // Execute callback
              if (config?.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      // Assign the handler to the registration object
      // eslint-disable-next-line no-param-reassign
      registration.onupdatefound = handleUpdate;
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
};

const checkValidServiceWorker = (swUrl, config) => {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      if (import.meta.env.DEV) {
        console.log(
          'No internet connection found. App is running in offline mode.'
        );
      }
    });
};

const register = (config) => {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(window.location.href);

    // Don't register service worker if public URL doesn't match current origin
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl =
        `${window.location.origin}/sw.js?env=${import.meta.env.MODE}` +
        `&disableCache=${window.CONFIG.DISABLE_SW_BASED_CACHE}`;
      if (import.meta.env.DEV) {
        console.log('Service Worker URL:', swUrl);
      }
      if (isLocalhost) {
        // This is running on localhost
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost
        navigator.serviceWorker.ready.then(() => {
          if (import.meta.env.DEV) {
            console.log(
              'This web app is being served cache-first by a service ' +
                'worker. To learn more, visit https://cra.link/PWA'
            );
          }
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
};

const unregister = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
};

const updateServiceWorker = () => {
  navigator.serviceWorker.ready
    .then((registration) => {
      return registration.unregister();
    })
    .then(() => {
      if (import.meta.env.DEV) {
        console.log('Service worker unregistered.');
      }
      // Immediately register again
      register(); // Call your existing register function
    })
    .catch((error) => {
      console.error('Error unregistering service worker:', error);
    });
};

export { register, updateServiceWorker, unregister };
